import React, { useMemo, useState } from 'react'

const AppContext = React.createContext({
    appContext: { navbar: { open: false }, taskbar: { open: false } },
    setAppContext: () => {},
})

export const AppProvider = ({ children }) => {
    const [appContext, setAppContext] = useState({
        navbar: { open: false },
        taskbar: { open: false },
    })
    const value = useMemo(() => ({ appContext, setAppContext }), [appContext])
    return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}

export default AppContext
